import { render, staticRenderFns } from "./CollectiveView.vue?vue&type=template&id=d5e9b92c"
import script from "./CollectiveView.vue?vue&type=script&lang=js"
export * from "./CollectiveView.vue?vue&type=script&lang=js"
import style0 from "./CollectiveView.vue?vue&type=style&index=0&id=d5e9b92c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports